export enum ORDER_TYPE {
  GIFT_STORE = 1,
  RESTAURANT = 2,
}
